import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.004.031a6 6 0 100 12 6 6 0 000-12zm.015 9.884a.877.877 0 110-1.755.877.877 0 010 1.755zm.653-3.448l.234-3.374a.905.905 0 10-1.805 0l.235 3.374a.67.67 0 001.336 0z",
    fill: "#EFA331"
  })));
}

export { SvgWarning as ReactComponent };
